// extracted by mini-css-extract-plugin
export default {"header":"v1Abpl6exaMsbGl1TTFW","control":"lQgFYBAEiYRRCK9NWqOI","segmentLabel":"zD43LsBIIERTUokTmpSI","hidden":"tUpMtTDtq8YyNiNxFXzU"};